import z from "zod";
export const NippleStimulateStyleSchema = z.enum([
    "circle",
    "side-to-side",
    "up-and-down",
]);
export const nippleStimulateStyle = NippleStimulateStyleSchema.options;
